{
  "en": {
    "employee": {
      "actions": {
        "accessProjects": "Manage projects access",
        "cancel": "Undo",
        "changeProfilePicture": "Change Profile Picture",
        "change_role": "Change role to",
        "download": "Download",
        "new": "Team Member",
        "profilePictureFormat": "Should be at least 300x300px",
        "save": "Save",
        "searchEmployee": "Search Team Member",
        "sendinvitation": "Create and send Invitation",
        "submit": "Save",
        "undoChanges": "Undo"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Once per day (around noon)",
          "hourly": "Every hour",
          "twice_daily": "Twice per day (morning/noon)",
          "weekly": "Once per week (Monday noon)"
        },
        "first_name": "First name",
        "language": "Language",
        "last_name": "Last name",
        "phone_landline": "Landline number",
        "phone_mobile": "Mobile number",
        "profession": "Job title",
        "role": "Access rights",
        "signature_html": "Conversation Signature",
        "status": "Status",
        "title": "Title"
      },
      "integrations": {
        "hide_details": "Hide details",
        "last_synced_at": "Last synced at: {time}",
        "show_details": "Show details"
      },
      "labels": {
        "all_projects": "All projects",
        "confirmChangeRole": "Are you sure you want to change the role of {name} to {role}?",
        "confirmPasswordReset": "An email has been sent with a link to reset your password, please check your inbox. Contact us if you experience any problems.",
        "disabled": {
          "access": "We will grant all employees access to the platform from the moment the last overdue invoice is paid.",
          "contact": "Contact us",
          "overdue": "We noticed your last invoice is long overdue. We revoked access for all employees on this platform. Partners and customers will still be able to access their data.",
          "title": "Your account has been disabled!"
        },
        "display": "Display",
        "filters": "Filters",
        "generalNotifications": "Notify me about",
        "has_access_to": "Has access to",
        "information": "Profile Information",
        "informationNotificationsEmail": "Receive an overview via e-mail, including only notifications you haven't seen yet on the platform.",
        "informationNotificationsPlatform": "Receive all notifications in your personal overview on the top right of the screen",
        "informationNotificationsTitle": "Decide what kind of notifications you want to receive and how",
        "its_you!": "It's you!",
        "last_login": "Last login",
        "maintainerAccess": "Requires access per project.",
        "name": "Name",
        "search_by_name_or_email": "Search by name or email",
        "onPlatform": "On Platform",
        "ownerAccess": "Has access to all projects and content on the {client_name} platform.",
        "password": "Password",
        "permissions": "Access rights for",
        "permissionsOwnerOnly": "As a Project Maintainer you cannot perform this action. Please ask a {client_name} team member with Owner role to do this for you.",
        "projectMaintains": "{first_name} has access to the following projects:",
        "projectMaintainsAdd": "To grant access, select a project and add {first_name} as a Project Maintainer under the Information feature.",
        "projectMaintainsNone": "doesn't have access to any projects.",
        "projectNotifications": "For project",
        "show_signature": "Show signature",
        "signature_active": "Signature active",
        "signature_info": "This signature will be added to replies sent to customers and partners.",
        "sorting": "Sorting",
        "viaEmail": "Via Email"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Accessible",
          "description": "Changes are saved automatically",
          "not_accessible": "Not accessible",
          "title": "Update project accessibility for {first_name} {last_name}"
        }
      },
      "roles": {
        "maintainer": "Maintainer",
        "owner": "Owner"
      },
      "toasts": {
        "create": "Team member has been created",
        "update": "Team member has been updated"
      },
      "validation": {
        "emailTaken": "Email address has already been used",
        "mustBeEmailAddress": "Valid email address required",
        "needFirstName": "First name required",
        "needLastName": "Last name required",
        "requireEmailAddress": "Email required",
        "role": "Select access rights"
      }
    }
  }
}
